<template>
  <div>
    <CRow>
      <CCol sm="12">
        <SalesTable
          :items="sales"
          :pagination="salesPagination"
          type="cedis"
          :reference="cedis_id"
          hover
          striped
          border
          small
          fixed
          caption="Historial de Ventas"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SalesTable from '../../components/sales/SalesTable.vue'

import { DatePicker } from 'v-calendar'
import moment from 'moment';
import moment_timezone from 'moment-timezone';

import ws from '../../services/sales';
import store from '../../store'

export default {
  name: 'CedisSales',
  components: { SalesTable },
  data: function () {
		return {
            sales: [],
    salesPagination: {},
            range: {
              start: new moment().startOf('month').toDate(),
              end: new moment().endOf("month").toDate(),
            },
        }
  },
  mounted: async function() {
    this.loading();

    this.cedis_id = await this.$route.params.id;

    let filters = {
      date : [moment(this.range.start).format("YYYY-MM-DD"),moment(this.range.end).format("YYYY-MM-DD")],
      supplier_id : 0,
      cedis_id : this.cedis_id,
      customer_id : 0,
      page: 1,
      per_page: 100
    };

    let response = await ws.getFiltered(filters);

    if(response.type == "success"){
      const normalized = this.normalizePayload(response);
      this.sales = normalized.items;
      this.salesPagination = normalized.pagination;
    }

    this.loaded();
  },
  methods: {
    normalizePayload (payload) {
      if (!payload) {
        return { items: [], pagination: {} };
      }

      const items = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : [];

      return {
        items,
        pagination: payload.pagination || {}
      };
    },
    refreshItems (response){
      this.loading();
      const normalized = this.normalizePayload(response);
      this.sales = normalized.items;
      this.salesPagination = normalized.pagination;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
